import React, { useState, useEffect, useCallback } from "react";
import {
  Avatar,
  Form,
  Input,
  Select,
  Button,
  Row,InputNumber,
  Col,
  DatePicker,
  notification,
  message
} from "antd";
import dayjs from 'dayjs';
import moment from 'moment'; 
import { useDropzone } from "react-dropzone";

import NoAvatar from "../../../../assets/img/png/no-avatar.png";
import {
  uploadAvatarApi,
  getAvatarApi,
} from "../../../../api/user";
import { getAccessTokenApi } from "../../../../api/auth";
import { put } from "../../../../api/put";
import "./EditWorkersForm.scss";

export default function EditWorkersForm(props) {
  const { worker, setIsVisibleModal, setReloadWorkers } = props;
  const [avatar, setAvatar] = useState(null);
  const [workerData, setWorkerData] = useState({});

  useEffect(() => {
    // worker.capacityitems= parseInt(worker.capacityitems)
    // worker.capacityweigh= parseFloat(worker.capacityweigh)
    // console.log(parseInt(String(worker.initWorkDate).split('-')[2]))
    // console.log(parseInt(String(worker.initWorkDate).split('-')[1]))
    // console.log(parseInt(String(worker.initWorkDate).split('-')[0]))
    setWorkerData({
      name: worker.name,
      email: worker.email,
      bornDate: worker.bornDate,
      frequencySalary: worker.frequencySalary,
      salary: worker.salary,
      timetable: worker.timetable,
      hours: worker.hours,
      frequencyHours: worker.frequencyHours,
      contactType: worker.contactType,
      initWorkDate: worker.initWorkDate,
      active: worker.active,
      avatar: worker.avatar,
    });
  }, [worker]);

  useEffect(() => {
    if (worker.avatar) {
      // getAvatarApi(worker.avatar).then((response) => {
      //   setAvatar(response);
      // });
      setAvatar(worker.avatar)
    } else {
      setAvatar(null);
    }
  }, [worker]);

  useEffect(() => {
    if (avatar) {
      setWorkerData({ ...workerData, avatar: avatar.file });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatar]);

  const updateWorker = (e) => {
   //console.log('he entrado al updateuser')
    e.preventDefault();
    const token = getAccessTokenApi();
    let workerUpdate = workerData;
      

    if (!workerUpdate.name ||
      !workerUpdate.email ||
      !workerUpdate.salary ||
      !workerUpdate.bornDate ||
      !workerUpdate.frequencySalary ||
      !workerUpdate.timetable ||
      !workerUpdate.hours ||
      !workerUpdate.frequencyHours ||
      !workerUpdate.contactType ||
      !workerUpdate.initWorkDate) {
      // notification["error"]({
      //   message: "Todos los campos son obligatorios",
      // });
      message.error("Todos los campos son obligatorios")
      return;
    }
    
    if (typeof workerUpdate.avatar === "object") {
      console.log('1')
      uploadAvatarApi(token, workerUpdate.avatar, worker.name,'upload-avatar-worker').then((response) => {
        workerUpdate.avatar = response.avatarName;
        put(workerUpdate,'update-worker','update-worker',`/${worker.name}` ).then((result) => {
        // updateWorkerApi(token, workerUpdate, vehicle.name).then((result) => {
          // notification["success"]({
          //   message:'Changes saved!',
          // });
          message.success('Changes saved!')
          setIsVisibleModal(false);
          setReloadWorkers(true);
        });
      });
    } else {
      put(workerUpdate,'update-worker','update-worker',`/${worker.name}` ).then((result) => {
      // updateWorkerApi(token, workerUpdate, vehicle.name).then((result) => {
        // notification["success"]({
        //   message: 'Changes saved!',
        // });
        message.success('Changes saved!')
        setIsVisibleModal(false);
        setReloadWorkers(true);
      });
    }
  };

  return (
    <div className="edit-user-form">
      <UploadAvatar avatar={avatar} setAvatar={setAvatar} />
      <EditForm
        workerData={workerData}
        worker={worker}
        setWorkerData={setWorkerData}
        updateWorker={updateWorker}
      />
    </div>
  );
}

function UploadAvatar(props) {
  const { avatar, setAvatar } = props;
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (avatar) {
      if (avatar.preview) {
        setAvatarUrl(avatar.preview);
      } else {
        setAvatarUrl(avatar);
      }
    } else {
      setAvatarUrl(null);
    }
  }, [avatar]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      // console.log(file)
      // console.log(URL.createObjectURL(file))
      setAvatar({ file, preview: URL.createObjectURL(file) });

    },
    [setAvatar]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: "image/jpeg, image/png",
    noKeyboard: true,
    onDrop,
  });

  return (
    <div className="upload-avatar" {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <Avatar size={150} src={NoAvatar} />
      ) : (
        <Avatar size={150} src={avatarUrl ? avatarUrl : NoAvatar} />
      )}
    </div>
  );
}

function EditForm(props) {
  const { workerData, setWorkerData, updateWorker,worker } = props;
  const { Option } = Select;

  return (
    <Form className="form-edit" onSubmit={updateWorker}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Name"
              value={workerData.name}
              onChange={(e) =>
                setWorkerData({ ...workerData, name: e.target.value })
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Email"
              value={workerData.email}
              onChange={(e) =>
                setWorkerData({ ...workerData, email: e.target.value })
                
              }
            /> 
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Salary'
              name='salary'
              min={0}
              max={999999}
              step={0.01}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={0} 
              value={workerData.salary}
              onChange={(e) => 
                {setWorkerData({ ...workerData, salary: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Payment type"
              onChange={(e) => setWorkerData({ ...workerData, frequencySalary: e })}
              value={workerData.frequencySalary}
              >
              <Option value="annual">Annual</Option>
              <Option value="monthly">Monthly</Option>
              <Option value="hours">Hours</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <InputNumber
              addonBefore='Working hours'
              name='hours'
              min={0}
              max={100}
              step={0.5}
              style={{
                margin: '0px 0px 0px 0px',
              }}
              // defaultValue={0} 
              value={workerData.hours}
              onChange={(e) => 
                {setWorkerData({ ...workerData, hours: e })}}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Frequency"
              onChange={(e) => setWorkerData({ ...workerData, frequencyHours: e })}
              value={workerData.frequencyHours}
              >
              <Option value="month">Per month</Option>
              <Option value="week">Per week</Option>
              <Option value="day">Per day</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>

      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <Input
              //prefix={<Icon type="user" />}
              placeholder="Timetable"
              value={workerData.timetable}
              onChange={(e) =>{
                setWorkerData({ ...workerData, timetable: e.target.value })}
              }
            /> 
          </Form.Item>
        </Col>
        <Col span={12}>
        <Form.Item>
            <Select
              placeholder="Contract type"
              onChange={(e) => setWorkerData({ ...workerData, contactType: e })}
              value={workerData.contactType}
              >
              <Option value="indefinite">Indefinite</Option>
              <Option value="temporary">Temporary</Option>
              <Option value="hourly">Hourly</Option>
            </Select>
            </Form.Item>
          </Col> 
      </Row>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item>
            <DatePicker 
            name='Birth Date'
            placeholder="Birth Date"
            value={moment(workerData.bornDate)}
            // value={dayjs().set('date',parseInt(String(workerData.bornDate).split('-')[2]))
            // .set('month',parseInt(String(workerData.bornDate).split('-')[1]-1))
            // .set('year',parseInt(String(workerData.bornDate).split('-')[0]))}
            
            onChange={(date, dateString)=>{
              // console.log(date, dateString)
              setWorkerData({ ...workerData, bornDate: dateString })
              
              }}/> 
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item>
          <DatePicker 
            name='Date of joining the company'
            placeholder="Date of joining the company"
            value={moment(workerData.initWorkDate)}
            // value={dayjs().set('date',parseInt(String(workerData.initWorkDate).split('-')[2]))
            // .set('month',parseInt(String(workerData.initWorkDate).split('-')[1]-1))
            // .set('year',parseInt(String(workerData.initWorkDate).split('-')[0]))}

            onChange={(date, dateString)=>{
              console.log(date)
              console.log(dateString)
              setWorkerData({ ...workerData, initWorkDate:dateString })
              }}/> 
            </Form.Item>
        </Col>
      </Row>
    <Row>
      <Form.Item>
        <Button style={{
      backgroundColor:'white',
      width:'225px',
      borderWidth:'2px',
      fontSize:'15px',
      color:'rgb(35,148,212)',
      fontFamily:'report-bold',
       }} type="primary" htmlType="submit" className="btn-submit" onClick={updateWorker}>
          Update worker
        </Button>
      </Form.Item>
    </Row>
    </Form>
  );
}
